/* eslint-disable react/prop-types */
import React from "react";
import ErrorBoundary from "../../../components/errorBoundary/errorBoundary";
import NavbarBottom from "./NavbarBottom";

const Navbar = (props) => {
  let {
    params: { id },
    organizationId,
    locationId,
    objectId,
    regionId,
    hideTitle,
    notifications
  } = props;

  return (
    <ErrorBoundary moduleName="NavbarBottom" {...notifications}>
      <NavbarBottom
        id={id}
        organization_id={organizationId}
        location_id={locationId}
        object_id={objectId}
        region_id={regionId}
        hideTitle={hideTitle}
      />
    </ErrorBoundary>
  );
};

export default Navbar;
